import { autoinject } from 'aurelia-dependency-injection';
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@autoinject
export class LeaveWithoutSavingDialog {

    private model: any;

    constructor(private dialogClientService: DialogClientService) {
    }

    activate(model) {
        this.model = model;
    }

    close() {
        this.model.close();
        this.dialogClientService.hide();
    }

    cancel() {
        this.model.cancel();
        this.dialogClientService.hide();
    }

    save() {
        this.model.save()
        this.dialogClientService.hide();
    }
}
